import { useField } from "vee-validate";

export function objComparatorICase(a, b, property) {
  return comparatorICase(a[property], b[property]);
}

export function comparatorICase(a, b) {
  let keyA = a.toUpperCase();
  let keyB = b.toUpperCase();
  if (keyA < keyB) return -1;
  if (keyA > keyB) return 1;
  return 0;
}

/**
 * IMPORTANT, use this function only after the useForm() call!
 * @param schema yup schema object
 */
export function getFormFromSchema(schema) {
  return Object.fromEntries(
    Object.keys(schema.fields).map(key => [key, useField(key, schema)])
  );
}

// This two function are agnostic about the baseUrl ending with slash or path starting with it!
export function getBaseUrl() {
  const envBaseUrl = import.meta.env.VITE_BASE_REST_URL;
  // Remove trailing slash from base if exists
  return envBaseUrl.endsWith('/') ? envBaseUrl.slice(0, -1) : envBaseUrl;
}

export function endpoint(path) {
  // Remove leading slash from path if exists
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return `${getBaseUrl()}/${normalizedPath}`;
}
